import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainClientTicket from '../../components/admin/ClientTicket/MainClientTicket'

const ClientTicket = () => {
  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainClientTicket/>
    </main>
  </div>
  )
}

export default ClientTicket
